/*
 * @Description: 实时定位驾驶舱 — A1「状态统计」本地 mock 数据
 *   仅 mock 开关开启时使用。数值与 locations.mock 保持自洽：
 *   10 个有设备成员（在线 7：移动 4 / 停留 3；离线 3）+ 2 个未绑定成员 → totalMembers 12。
 *   按接口文档口径：online + offline ≠ totalMembers（未绑定成员不进桶）。
 */
import {
  RealtimeSummaryHistory,
  RealtimeSummaryRealtime
} from '../types/cockpit.types'

/** 实时态（当天）状态统计 mock */
export const MOCK_SUMMARY_REALTIME: RealtimeSummaryRealtime = {
  isRealtime: true,
  totalMembers: 12,
  online: 7,
  moving: 4,
  staying: 3,
  offline: 3,
  abnormal: 2,
  firstReportTime: 1780848000000
}

/** 历史态（非当天）状态统计 mock */
export const MOCK_SUMMARY_HISTORY: RealtimeSummaryHistory = {
  isRealtime: false,
  totalMembers: 12,
  activeToday: 8
}

/**
 * 异常成员的 userId 集合 mock（对应 A1.abnormal=2）。
 * 真实来源为 D/alerts 未结告警，后续期接入后替换；本期供「异常」状态筛选联动地图用。
 */
export const MOCK_ABNORMAL_USER_IDS: string[] = ['mock-u8', 'mock-u9']
